import {
  httpAdmin,
  httpEnrollmentClient,
  httpClient,
} from '../common/httpClient';
import API_CONST from '@/constants/ApiConst';

export function getSiteByProgramId(programId: number) {
  return httpEnrollmentClient()
    .get(`${API_CONST.GET_ENROL_WAITLIST_COUNT}/${programId}`)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      return {
        data: error.data,
        status: error.status,
        statusText: error.statusText,
      };
    });
}

export function getAccountSettings(accountId: number) {
  return httpAdmin({ interceptor: true })
    .get(`${API_CONST.PROGRAM_SITES_BY_ACC_ID}/account/${accountId}`)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      return {
        data: error.data,
        status: error.status,
        statusText: error.statusText,
      };
    });
}

export function getAccountDetail(accountId: string) {
  return httpAdmin({ interceptor: true })
    .get(`${API_CONST.ACCOUNT_BY_ID}/${accountId}`)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      return {
        data: error.data,
        status: error.status,
        statusText: error.statusText,
      };
    });
}

export function getProgramSitesByAccId(accountId: number) {
  return httpAdmin({ interceptor: true })
    .get(`${API_CONST.PROGRAM_SITES_BY_ACC_ID}/account/${accountId}`)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      return {
        data: error.data,
        status: error.status,
        statusText: error.statusText,
      };
    });
}
export function getInProgressApplications(guardianId: number): Promise<any> {
  return httpEnrollmentClient()
    .get(
      `${API_CONST.GET_APPLICATIONS_BY_GUARDIAN}/${guardianId}/isAllEnrollment/false`
    )
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      return {
        data: error.data,
        status: error.status,
        statusText: error.statusText,
      };
    });
}

export function updateScholarData(payload: any) {
  return httpEnrollmentClient()
    .put(`${API_CONST.UPDATE_SCHOLAR_DATA}${payload.guid}`, payload)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      const res = error;
      return {
        data: res.data.Message || res.data.value || res.data,
        status: res.status,
        statusText: res.statusText,
      };
    });
}

export function getDocumentByApplicationGuid(applicationGuid: string) {
  return httpEnrollmentClient()
    .get(`${API_CONST.APPLICATION_DOCUMENT}${applicationGuid}`)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      const res = error;
      return {
        data: res.data.Message || res.data.value || res.data,
        status: res.status,
        statusText: res.statusText,
      };
    });
}

export function addDocument(payload: any, formData?: any) {
  let queryString = '';
  for (var k in payload) {
    if (payload[k]) {
      queryString = queryString + k + '=' + payload[k] + '&';
    }
  }
  queryString = queryString.slice(0, -1);
  return httpEnrollmentClient()
    .post(`${API_CONST.SCHOLAR_DOCUMENT}?${queryString}`, formData)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      const res = error;
      return {
        data: res.data.Message || res.data.value || res.data,
        status: res.status,
        statusText: res.statusText,
      };
    });
}

export function updateDocument(applicationId: string, payload: any) {
  return httpEnrollmentClient()
    .put(`${API_CONST.UPDATE_DOCUMENT}?applicationId=${applicationId}`, payload)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      const res = error;
      return {
        data: res.data.Message || res.data.value || res.data,
        status: res.status,
        statusText: res.statusText,
      };
    });
}

export function updateAuthorizePickupData(scholarGuid: any, payload: any) {
  return httpEnrollmentClient()
    .put(
      `${API_CONST.UPDATE_AUTHORIZE_PICKUP}?scholarGuid=${scholarGuid}`,
      payload
    )
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      const res = error;
      return {
        data: res.data.Message || res.data.value || res.data,
        status: res.status,
        statusText: res.statusText,
      };
    });
}
export function updateProgramDetails(payload: any) {
  return httpEnrollmentClient()
    .put(`${API_CONST.UPDATE_PROGRAM_DETAILS}`, payload)
    .then((response) => {
      return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      };
    })
    .catch((error) => {
      const res = error;
      return {
        data: res.data.Message || res.data.value || res.data,
        status: res.status,
        statusText: res.statusText,
      };
    });
}
